// services/adminReturnExchange.service.ts
import axiosInstance from ".";

interface UpdateReturnStatusBody {
  status: "Pending" | "Approved" | "Rejected";
}

// Get all return/exchange requests
export const getAllReturnsAPI = async () => {
  const response = await axiosInstance.get(`/admin/returns`);
  return response;
};

// Update return/exchange status
export const updateReturnStatusAPI = async ({ id, body }: { id: string; body: UpdateReturnStatusBody }) => {
  const response = await axiosInstance.patch(`/admin/returns/${id}/status`, body);
  return response;
};
